<template>
  <div id="invoice">
    <!-- 手动录入信息 -->
    <div class="invoice-form" v-if="isHandle">
      <div v-if="invoiceType === 'service'" style="margin-bottom:10px;">
        <span style="color:#ed4014;">请注意，未收取服务费先开发票必须填写正确发票金额</span>
      </div>
      <Form ref="invoiceForm" :model="invoiceData" :rules="ruleInvoice" inline>
        <FormItem label="发票金额" :label-width="80" required>
          <Input style="width:100px;" v-model="invoiceData.totalLowerPrice"></Input>
        </FormItem>
        <FormItem label="税率" :label-width="80" prop="goodstax">
          <Input style="width:90px;" v-model="invoiceData.goodstax"></Input>%
        </FormItem>
        <FormItem label="发票号码" :label-width="80" prop="invoiceNum" :required="!ifMakeInvoice">
          <Input style="width:120px;" v-model="invoiceData.invoiceNum" :disabled="ifMakeInvoice"></Input>
        </FormItem>
        <!-- <FormItem label="发票代码" :label-width="80" prop="invoiceCode">
            <Input style="width:180px;" v-model="invoiceData.invoiceCode"></Input>
          </FormItem> -->
        <FormItem label="开票日期" :label-width="80" prop="invoiceDate" :required="!ifMakeInvoice">
          <!-- <Input style="width:130px;" v-model="invoiceData.invoiceDate"></Input> -->
          <DatePicker type="date" style="width: 150px" v-model="invoiceData.invoiceDate" :disabled="ifMakeInvoice"></DatePicker>
        </FormItem>
        <div>
          <FormItem label="收款人" :label-width="80" prop="payee">
            <Input style="width:100px;" v-model="invoiceData.payee"></Input>
          </FormItem>
          <FormItem label="复核人" :label-width="80" prop="check">
            <Input style="width:100px;" v-model="invoiceData.check"></Input>
          </FormItem>
          <FormItem label="开票人" :label-width="80" prop="drawer">
            <Input style="width:100px;" v-model="invoiceData.drawer"></Input>
          </FormItem>
          <!-- <FormItem v-if="invoiceType === 'service'">
            <Checkbox style="margin-left:50px;" v-model="ifMakeInvoice">暂不开发票</Checkbox>
          </FormItem> -->
        </div>
        <div v-if="false">
          <FormItem label="购买方纳税人识别号" :label-width="130" prop="buyerCode">
            <Input style="width:280px;" v-model="invoiceData.buyerCode"></Input>
          </FormItem>
          <FormItem label="购买方公司名称" :label-width="130" prop="buyerName">
            <Input style="width:280px;" v-model="invoiceData.buyerName"></Input>
          </FormItem>
          <FormItem label="购买方公司地址" :label-width="130" prop="buyerAddress">
            <Input style="width:280px;" v-model="invoiceData.buyerAddress"></Input>
          </FormItem>
          <FormItem label="购买方联系号码" :label-width="130" prop="buyerPhone">
            <Input style="width:280px;" v-model="invoiceData.buyerPhone"></Input>
          </FormItem>
          <FormItem label="购买方开户银行名称" :label-width="130" prop="buyerAccountName">
            <Input style="width:280px;" v-model="invoiceData.buyerAccountName"></Input>
          </FormItem>
          <FormItem label="购买方银行账号" :label-width="130" prop="buyerAccount">
            <Input style="width:280px;" v-model="invoiceData.buyerAccount"></Input>
          </FormItem>
          <FormItem label="销售方纳税人识别号" :label-width="130" prop="salesCode">
            <Input style="width:280px;" v-model="invoiceData.salesCode"></Input>
          </FormItem>
          <FormItem label="销售方公司名称" :label-width="130" prop="salesName">
            <Input style="width:280px;" v-model="invoiceData.salesName"></Input>
          </FormItem>
          <FormItem label="销售方公司地址" :label-width="130" prop="salesAddress">
            <Input style="width:280px;" v-model="invoiceData.salesAddress"></Input>
          </FormItem>
          <FormItem label="销售方联系号码" :label-width="130" prop="salesPhone">
            <Input style="width:280px;" v-model="invoiceData.salesPhone"></Input>
          </FormItem>
          <FormItem label="销售方开户银行名称" :label-width="130" prop="salesAccountName">
            <Input style="width:280px;" v-model="invoiceData.salesAccountName"></Input>
          </FormItem>
          <FormItem label="销售方银行账号" :label-width="130" prop="salesAccount">
            <Input style="width:280px;" v-model="invoiceData.salesAccount"></Input>
          </FormItem>
        </div>
      </Form>
    </div>
    <div v-show="!isHandle || isPreviewed">
      <div style="color:red;padding:0 10px;">
        *请注意购买方名称，纳税人识别号，税率，价税合计，开票人等信息（此电子发票信息仅供预览参考）
      </div>
      <div style="margin-left:30px">
        <Checkbox v-model="ifShowInfo">发票显示购买方地址，电话，开户行及账号</Checkbox>
        <Checkbox v-if="newInvoicePermission" v-model="ifNewInvoice" style="margin-left:16px;">诺诺电子发票（深圳使用）</Checkbox>
      </div>
      <div class="invoice-page">
        <div class="header">
          <div class="header-left">
            <!-- 二维码 -->
            <div style="width:66px;height:66px;"></div>
            <div>
              <span>机器编号：</span>
              <input type="text" readonly v-model="invoiceData.robotNum">
            </div>
          </div>
          <div class="header-img">
            <img src="../images/发票头部.png">
          </div>
          <div class="header-right">
            <div>
              <span>发票代码：</span>
              <input type="text" readonly v-model="invoiceData.invoiceCode">
            </div>
            <div>
              <span>发票号码：</span>
              <input type="text" readonly v-model="invoiceData.invoiceNum">
            </div>
            <div>
              <span>开票日期：</span>
              <input type="text" readonly v-model="showInvoiceDate">
            </div>
            <div>
              <span>校&nbsp;&nbsp;验&nbsp;码：</span>
              <input type="text" readonly v-model="invoiceData.checkCode">
            </div>
          </div>
        </div>
        <div class="table-data">
          <div class="tr tr1">
            <div class="td td11">购买方</div>
            <div class="td td12">
              <div>
                <span>名&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;称：</span>
                <input type="text" style="width: 300px;" readonly v-model="invoiceData.buyerName">
              </div>
              <div>
                <span>纳税人识别号：</span>
                <input type="text" style="width: 300px;" readonly v-model="invoiceData.buyerCode">
              </div>
              <div>
                <span>地址、&nbsp;&nbsp;&nbsp;电话：</span>
                <input type="text" placeholder="地址" :readonly="!ifShowInfo" v-model="invoiceData.buyerAddress" style="width: 200px;">
                <input type="text" placeholder="电话" :readonly="!ifShowInfo" v-model="invoiceData.buyerPhone" style="width: 100px;">
              </div>
              <div>
                <span>开户行及账号：</span>
                <input type="text" placeholder="开户行" :readonly="!ifShowInfo" v-model="invoiceData.buyerAccountName" style="width: 200px;">
                <input type="text" placeholder="账号" :readonly="!ifShowInfo" v-model="invoiceData.buyerAccount" style="width: 100px;">
              </div>
            </div>
            <div class="td td13">密码区</div>
            <div class="td td14"></div>
          </div>
          <div class="tr tr2">
            <div class="td td21">
              <div>货物或应税劳务、服务名称</div>
              <div>
                <input type="text" readonly style="width: 190px;" v-model="invoiceData.goodsName">
              </div>
              <div style="position:absolute;bottom:0;width:200px">
                <span>合&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;计</span>
              </div>
            </div>
            <div class="td td22">
              <div>
                <span>规格型号</span>
                <input class="right-text" readonly style="width:55px;" type="text" v-model="invoiceData.goodsType">
              </div>
            </div>
            <div class="td td23">
              <div>
                <span>单位</span>
                <input class="right-text" readonly style="width:40px;" type="text" v-model="invoiceData.goodsUnit">
              </div>
            </div>
            <div class="td td24">
              <div>
                <span>数&nbsp;&nbsp;量</span>
                <input class="right-text" readonly style="width:85px;" type="text" v-model="invoiceData.goodsCount">
              </div>
            </div>
            <div class="td td25">
              <div>
                <span>单&nbsp;&nbsp;价</span>
                <input class="right-text" readonly style="width:90px;" type="text" v-model="invoiceData.goodsPrice">
              </div>
            </div>
            <div class="td td26">
              <div>
                <span>金&nbsp;&nbsp;&nbsp;&nbsp;额</span>
                <input class="right-text" readonly style="width:108px;" type="text" v-model="invoiceData.goodsTotalPrice">
              </div>
              <div style="position:absolute;bottom:0;width:112px">
                <input class="right-text" readonly type="text" style="width:108px;" v-model="invoiceData.goodsTotalPriceTotal">
              </div>
            </div>
            <div class="td td27">
              <div>
                <span>税率</span>
                <input class="right-text" style="width:20px;" type="text" v-model="invoiceData.goodstax">
                <span style="color:#000">%</span>
              </div>
            </div>
            <div class="td td28">
              <div>
                <span>税&nbsp;&nbsp;&nbsp;&nbsp;额</span>
                <input class="right-text" readonly style="width:115px;" type="text" v-model="invoiceData.goodsTaxPrice">
              </div>
              <div style="position:absolute;bottom:0;width:115px">
                <input class="right-text" readonly type="text" style="width:115px;" v-model="invoiceData.goodsTaxPriceTotal">
              </div>
            </div>
          </div>
          <div class="tr tr3">
            <div class="td td31">
              <span>价税合计(大写)</span>
            </div>
            <div class="td td32">
              <input type="text" readonly style="position:absolute;left:5px;top:9px;" v-model="invoiceData.totalUpperPrice">
              <div style="position:absolute;left:365px;">
                <span>(小写)</span>
                <span style="color:#000;">￥</span>
                <input type="text" style="width: 100px;" readonly v-model="invoiceData.totalLowerPrice">
              </div>
            </div>
          </div>
          <div class="tr tr4">
            <div class="td td41">销售方</div>
            <div class="td td42">
              <div>
                <span>名&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;称：</span>
                <input type="text" readonly v-model="invoiceData.salesName">
              </div>
              <div>
                <span>纳税人识别号：</span>
                <input type="text" readonly v-model="invoiceData.salesCode">
              </div>
              <div>
                <span>地址、&nbsp;&nbsp;&nbsp;电话：</span>
                <input type="text" readonly v-model="salesAddressAndPhone" style="position:absolute;width:350px;">
              </div>
              <div style="position:relative">
                <span>开户行及账号：</span>
                <input type="text" readonly v-model="salesAccountAndName" style="position:absolute;width:350px;">
              </div>
            </div>
            <div class="td td43">备<br/><br/>注</div>
            <div class="td td44"></div>
          </div>
        </div>
        <div style="position: relative;margin-top: 10px;">
          <div style="position: absolute;left: 45px;">
            <span>收款人：</span>
            <input type="text" placeholder="收款人" v-model="invoiceData.payee">
          </div>
          <div style="position: absolute;left: 255px;">
            <span>复核：</span>
            <input type="text" style="width: 120px;" placeholder="复核人" v-model="invoiceData.check">
          </div>
          <div style="position: absolute;left: 420px;">
            <span>开票人：</span>
            <input type="text" style="width: 100px;" placeholder="开票人" v-model="invoiceData.drawer">
          </div>
          <div style="position: absolute;left: 580px;">
            <span>销售方：(章)</span>
          </div>
        </div>
      </div>
    </div>
    <div style="text-align:right;padding: 0 20px;">
      <Button @click="isPreviewed=true" style="margin-right: 10px;" v-if="isHandle && !isPreviewed">预览</Button>
      <Button @click="isPreviewed=false" style="margin-right: 10px;" v-if="isHandle && isPreviewed">收起</Button>
      <Button @click="cancelInvoice" style="margin-right: 10px;">取消</Button>
      <Button type="primary" @click="makeInvoice">确认</Button>
    </div>
  </div>
</template>

<script>
import ajax from '../lib/ajax.ts'
import requestUrls from '../lib/requestUrls'

export default {
  name: '',
  props: {
    invoicePropData: {
      type: Object
    },
    isHandle: {
      type: Boolean,
      default: false
    },
    invoiceType: {
      type: String
    }
  },
  data() {
    return {
      ifShowInfo: false,
      companiesTax: [],
      invoiceData: {
        robotNum: '',
        invoiceCode: '',
        invoiceNum: '',
        invoiceDate: '',
        checkCode: '',
        buyerName: '',
        buyerCode: '',
        buyerAddress: '',
        buyerPhone: '',
        buyerAccount: '',
        buyerAccountName: '',
        goodsName: '*现代服务*招标服务费',
        goodsType: '',
        goodsUnit: '',
        goodsCount: '1',
        goodsPrice: '',
        goodsTotalPrice: '',
        goodstax: '6',
        goodsTaxPrice: '',
        goodsTotalPriceTotal: '',
        goodsTaxPriceTotal: '',
        totalUpperPrice: '',
        totalLowerPrice: '',
        salesName: '采联国际招标采购集团有限公司',
        salesCode: '914401047860726701 ',
        salesAddress: '广州市越秀区环市东路472号23楼',
        salesPhone: '020-87651688',
        salesAccountName: '广发银行股份有限公司广州白云机场支行',
        salesAccount: '9550880004679000499',
        payee: '唐惠英',
        check: '何梓豪',
        drawer: ''
      },
      isPreviewed: false,
      ruleInvoice: {
        // totalLowerPrice: [
        //   { required: true, message: '不能为空', trigger: 'blur' }
        // ],
        goodstax: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        payee: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        check: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        drawer: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        buyerCode: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        buyerName: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        buyerAddress: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        buyerPhone: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        buyerAccountName: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        buyerAccount: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        salesCode: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        salesName: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        salesAddress: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        salesPhone: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        salesAccountName: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        salesAccount: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        salesAccount: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        // invoiceCode: [
        //   { required: true, message: '不能为空', trigger: 'blur' }
        // ],
        // invoiceNum: [
        //   { required: true, message: '不能为空', trigger: 'blur' }
        // ],
        // invoiceDate: [
        //   { required: true, type: 'date', message: '不能为空', trigger: 'blur' }
        // ],
      },
      ifMakeInvoice: false,
      ifNewInvoice: false
    }
  },
  async mounted() {
    if (!this.$store.state.session.user) {
      await this.$store.dispatch({
        type: 'session/init'
      })
    }
    this.invoiceData.drawer = this.$store.state.session.user.name
  },
  computed: {
    newInvoicePermission() {
      const permission = this.$store.getters['session/hasRoles']('深圳电子发票')
      if (permission) {
        this.ifNewInvoice = true
      }
      return permission
    },
    // buyerAddressAndPhone() {
    //   return this.invoiceData.buyerAddress + ' ' + this.invoiceData.buyerPhone
    // },
    // buyerAccountAndName() {
    //   return this.invoiceData.buyerAccountName + ' ' + this.invoiceData.buyerAccount
    // },
    salesAddressAndPhone() {
      return this.invoiceData.salesAddress + ' ' + this.invoiceData.salesPhone
    },
    salesAccountAndName() {
      return this.invoiceData.salesAccountName + ' ' + this.invoiceData.salesAccount
    },
    showInvoiceDate() {
      if (this.invoiceData.invoiceDate) {
        let count = 0
        let str = ['年', '月']
        let date = new Date(this.invoiceData.invoiceDate).toLocaleDateString().replace(/\//g, () => {
          return str[count++]
        })
        date += '日'
        return date
      } else {
        return ''
      }
    }
  },
  methods: {
    makeInvoice() {
      if (!this.isHandle) {
        // 电子发票
        this.validInvoice().then(res => {
          this.$Modal.confirm({
            title: '确认开票',
            content: '<div><span style="color:#ed3f14">此操作将开出发票</span>,请仔细查看发票信息，确认发票信息准确无误。</div>',
            onOk: async () => {
              this.spinShow('正在开票，请稍后..')
              try {
                let data = {
                  sl: parseInt(this.invoiceData.goodstax) / 100 + '',
                  orderNo: this.invoicePropData.orderNo,
                  kpr: this.invoiceData.drawer,
                  skr: this.invoiceData.payee,
                  fhr: this.invoiceData.check,
                  ordersId: this.invoicePropData.id,
                  ghfdz: '',
                  ghfgddh: '',
                  ghfyhzh: '',
                }
                if (this.ifShowInfo) {
                  data.ghfdz = this.invoiceData.buyerAddress
                  data.ghfgddh = this.invoiceData.buyerPhone
                  data.ghfyhzh = `${this.invoiceData.buyerAccountName} ${this.invoiceData.buyerAccount}`
                }
                
                let rep = {}
                if (this.ifNewInvoice) {
                  rep = await ajax.post(requestUrls.orderInvoice.NnOpenInvoice, data)
                } else {
                  rep = await ajax.post(requestUrls.orderInvoice.openInvoice, data)
                }

                if (rep.data.success) {
                  // 修改订单状态
                  let orderRep = await ajax.put(requestUrls.order.updateOrder, {
                    id: this.invoicePropData.id,
                    orderStatus: '3'
                  })
                  let pdfUrl = rep.data.result.pdfUrl
                  if (this.ifNewInvoice && !rep.data.result.pdfUrl) {
                    pdfUrl = '（诺诺发票不会有实时链接）'
                  }
                  if (orderRep.data.success) {
                    this.$emit('finishInvoice')
                    this.$Modal.success({
                      title: '开票成功',
                      content: `<div>电子发票链接为：${pdfUrl}，请注意查收</div>`
                    })
                  }
                } else {
                  this.$Message.error('开票失败，请重新尝试')
                }
                this.$Spin.hide()
              } catch (err) {
                console.error(err)
                this.$Spin.hide()
              }
            }
          })
        })
      } else {
        // if (!this.ifMakeInvoice && this.invoiceData.invoiceNum === '') {
        //   this.$Message.error('发票号码不能为空')
        //   return
        // }
        // if (!this.ifMakeInvoice && this.invoiceData.invoiceDate === '') {
        //   this.$Message.error('开票日期不能为空')
        //   return
        // }
        // 录入发票
        this.$refs.invoiceForm.validate(valid => {
          if (valid) {
            // 写在rule下有问题
            if (this.invoiceData.totalLowerPrice === '') {
              this.$Message.error('发票金额不能为空')
              return
            }            
            // 税率检查
            let tax = parseInt(this.invoiceData.goodstax)
            if (tax > 100 || tax < 0 || isNaN(tax)) {
              this.$Message.error('请检查输入的税率')
              return
            }
            // 发票金额检查
            let price = parseInt(this.invoiceData.totalLowerPrice)
            if (isNaN(price)) {
              this.$Message.error('请检查输入的金额')
              return
            }
            if (this.invoiceData.totalLowerPrice !== this.invoicePropData.orderAmountTotal) {
              this.$Message.warning('请注意：输入金额与订单金额不相等')
            }
            this.$Modal.confirm({
              title: '确认开票',
              content: '<div><span style="color:#ed3f14">此操作将开出发票</span>,请仔细查看发票信息，确认发票信息准确无误。</div>',
              onOk: async () => {
                this.spinShow('正在录入发票，请稍候..')
                try {
                  let invoiceTime = ''
                  if (this.invoiceData.invoiceDate) {
                    invoiceTime = new Date(this.invoiceData.invoiceDate).toLocaleDateString().replace(/\//g, '-')
                  }
                  let invoiceUrl = requestUrls.orderInvoice.ManualInvoice
                  if (this.invoiceType === 'service') {
                    invoiceUrl = requestUrls.orderInvoice.ServiceInvoice
                  }
                  let rep = await ajax.post(invoiceUrl, {
                    // "invoiceType": "1", // 1正票 2红票
                    "invoiceHm": this.invoiceData.invoiceNum,
                    // "invoiceDm": this.invoiceData.invoiceCode,
                    "invoiceAmount": this.invoiceData.totalLowerPrice,
                    "taxRate": parseInt(this.invoiceData.goodstax) / 100 + '',
                    "invoiceTime": invoiceTime,
                    "kpr": this.invoiceData.drawer,
                    "skr": this.invoiceData.payee,
                    "fhr": this.invoiceData.check,
                    // "inputMode": "手动发票",
                    "orderNo": this.invoicePropData.orderNo,
                    "isNotInvoice": this.ifMakeInvoice,
                    "ordersId": this.invoicePropData.id
                  })
                  if (rep.data.success) {
                    // 修改订单状态
                    if (this.invoicePropData.orderStatus === '2') {
                      let orderStatus = '3'
                      // if (this.invoicePropData.orderStatus === '5') {
                      //   orderStatus = '5'
                      // }
                      let orderRep = await ajax.put(requestUrls.order.updateOrder, {
                        id: this.invoicePropData.id,
                        orderStatus: orderStatus
                      })
                    }
                    // if (orderRep.data.success) {
                    //   this.$emit('finishInvoice')
                    //   this.$Message.success('开票成功')
                    // }
                    this.$emit('finishInvoice')
                    this.$Message.success('开票成功')
                  } else {
                    this.$Message.error('开票失败，请重新尝试')
                  }
                  this.$Spin.hide()
                } catch (err) {
                  this.$Spin.hide()
                  this.$Message.error('开票失败')
                }
              }
            })
          }
        })
      }
    },
    validInvoice() {
      const invoiceData = this.invoiceData
      let validate = true
      // 购买方名称
      if (!invoiceData.buyerName) {
        this.$Message.error('购买方名称不能为空')
        validate = false
      }
      // 购买方纳税人识别号
      // if (!invoiceData.buyerCode) {
      //   this.$Message.error('购买方纳税人识别号不能为空')
      //   validate = false
      // }
      // 税率
      let tax = parseInt(invoiceData.goodstax)
      if (!invoiceData.goodstax && tax !== 0) {
        this.$Message.error('税率不能为空')
        validate = false
      } else if (tax > 100 || tax < 0 || isNaN(tax)) {
        this.$Message.error('请检查输入的税率')
        validate = false
      }
      // 开票人
      if (!invoiceData.drawer) {
        this.$Message.error('开票人不能为空')
        validate = false
      }
      // 收款人
      if (!invoiceData.payee) {
        this.$Message.error('收款人不能为空')
        validate = false
      }
      // 复核人
      if (!invoiceData.check) {
        this.$Message.error('复核人不能为空')
        validate = false
      }
      // 项目单价
      if (!invoiceData.totalLowerPrice) {
        this.$Message.error('价税合计不能为空')
        validate = false
      }
      if (validate) {
        return Promise.resolve(true)
      } else {
        return Promise.reject(false)
      }
    },
    cancelInvoice() {
      this.$emit('cancelInvoice')
    },
    // 加载过程
    spinShow(text) {
      this.$Spin.show({
        render: (h) => {
          return h('div', [
            h('Icon', {
              'class': 'demo-spin-icon-load',
              props: {
                type: 'ios-loading',
                size: 18
              }
            }),
            h('div', text)
          ])
        }
      })
    },
    async getCompanyTax() {
      let rep = await ajax.get(requestUrls.bankAccount.getAll)
      if (rep.data.success) {
        this.companiesTax = rep.data.result.items
      }
    }
  },
  watch: {
    async invoicePropData(val) {
      if (val) {
        this.ifMakeInvoice = false
        // 清空旧数据
        this.invoiceData.payee = '唐惠英'
        this.invoiceData.check = '何梓豪'

        // 深圳诺诺电子发票相关人员名单
        if (this.newInvoicePermission) {
          this.invoiceData.payee = '许娜'
          this.invoiceData.check = '唐惠英'
        }

        // this.invoiceData.drawer = ''
        this.invoiceData.invoiceNum = ''
        this.invoiceData.invoiceCode = ''
        this.invoiceData.invoiceDate = ''
        this.invoiceData.totalLowerPrice = ''
        this.invoiceData.totalLowerPrice = val.orderAmountTotal

        // 购买方
        this.invoiceData.buyerName = ''
        this.invoiceData.buyerCode = ''
        this.invoiceData.buyerAddress = ''
        this.invoiceData.buyerPhone = ''
        this.invoiceData.buyerAccount = ''
        this.invoiceData.buyerAccountName = ''
        this.invoiceData.buyerName = val.ghfCompanyName
        this.invoiceData.buyerCode = val.ghfInvoiceTaxNo
        // this.invoiceData.buyerAddress = val.ghfCompanyAddress
        // this.invoiceData.buyerPhone = val.ghfTelphone
        // this.invoiceData.buyerAccount = val.ghfBankAccount
        // this.invoiceData.buyerAccountName = val.ghfBankName

        // 支付方
        this.invoiceData.salesName = ''
        this.invoiceData.salesCode = ''
        this.invoiceData.salesAddress = ''
        this.invoiceData.salesPhone = ''
        this.invoiceData.salesAccount = ''
        this.invoiceData.salesAccountName = ''
        this.invoiceData.salesName = val.xhfCompanyName
        this.invoiceData.salesCode = val.xhfInvoiceTaxNo
        this.invoiceData.salesAddress = val.xhfCompanyAddress
        this.invoiceData.salesPhone = val.xhfTelphone
        this.invoiceData.salesAccount = val.xhfBankAccount
        this.invoiceData.salesAccountName = val.xhfBankName

        if (this.companiesTax.length === 0) {
          await this.getCompanyTax()
        }
        for (let i = 0; i < this.companiesTax.length; i++) {
          let company = this.companiesTax[i]
          if (company.xhfCompanyName === val.xhfCompanyName) {
            this.invoiceData.goodstax = company.taxRate
            break
          }
        }
        
      }
    },
    ifMakeInvoice(val) {
      if (val) {
        this.invoiceData.invoiceNum = ''
      }
    },
    ifShowInfo(val) {
      if (val) {
        this.invoiceData.buyerAddress = this.invoicePropData.ghfCompanyAddress
        this.invoiceData.buyerPhone = this.invoicePropData.ghfTelphone
        this.invoiceData.buyerAccount = this.invoicePropData.ghfBankAccount
        this.invoiceData.buyerAccountName = this.invoicePropData.ghfBankName
      } else {
        this.invoiceData.buyerAddress = ''
        this.invoiceData.buyerPhone = ''
        this.invoiceData.buyerAccount = ''
        this.invoiceData.buyerAccountName = ''
      }
    }
  }
}
</script>

<style lang="less" scoped>
#invoice {
  background: #ddd;
  padding: 5px 0;
  color: rgb(158, 82, 10);
  .invoice-form {
    padding: 5px;
  }
  input {
    border: 0;
    height: 13px;
  }
  .right-text {
    text-align: right;
  }
  .invoice-page {
    width: 810px;
    height: 525px;
    margin: 20px auto;
    background: #fff;
    letter-spacing: 1px;
    .header {
      position: relative;
      height: 110px;
      font-size: 12px;
      .header-left {
        position: absolute;
        left: 40px;
        margin-top: 10px;
      }
      .header-img {
        position: absolute;
        left: 245px;
      }
      .header-right {
        position: absolute;
        left: 580px;
        margin-top: 10px;
        line-height: 23px;
      }
    }
  }
  .table-data {
    width: 760px;
    height: 350px;
    margin: 0 auto;
    box-sizing: border-box;
    border: 1px solid rgb(166, 77, 77);
    .tr + .tr {
      border-top: 1px solid rgb(166, 77, 77);
    }
    .tr {
      box-sizing: border-box;
      font-size: 0;
      .td {
        display: inline-block;
        font-size: 12px;
        box-sizing: border-box;
        vertical-align: top;
      }
      .td + .td {
        border-left: 1px solid rgb(166, 77, 77);
      }
    }
    .tr1 {
      word-wrap: break-word;
      text-align: center;
      .td {
        height: 80px;
      }
      .td11 {
        width: 25px;
        padding-top: 12px;
      }
      .td12 {
        width: 410px;
        text-align: left;
        padding-left: 5px;
        line-height: 20px;
      }
      .td13 {
        width: 20px;
        padding-top: 12px;
      }
      .td14 {
        width: 303px;
      }
    }
    .tr2 {
      text-align: center;
      .td {
        height: 165px;
      }
      .td21 {
        position: relative;
        width: 200px;
      }
      .td22 {
        width: 60px;
      }
      .td23 {
        width: 45px;
      }
      .td24 {
        width: 90px;
      }
      .td25 {
        width: 95px;
      }
      .td26 {
        width: 113px;
        position: relative;
      }
      .td27 {
        width: 35px;
      }
      .td28 {
        width: 120px;
        position: relative;
      }
    }
    .tr3 {
      text-align: center;
      .td {
        height: 30px;
        line-height: 30px;
      }
      .td31 {
        width: 200px;
      }
      .td32 {
        position: relative;
        width: 557px;
        text-align: left;
      }
    }
    .tr4 {
      text-align: center;
      .td {
        height: 71px;
      }
      .td41 {
        letter-spacing: 4px;
        padding: 8px 0 0 4px;
        width: 30px;
      }
      .td42 {
        width: 400px;
        text-align: left;
        padding-left: 5px;
        line-height: 18px;
        input {
          width: 300px;
        }
      }
      .td43 {
        padding-top: 8px;
        width: 20px;
      }
      .td44 {
        width: 307px;
      }
    }
  }
  .operate-invoice {
    margin: 30px;
  }
}
</style>
